export const SITE_NAME = 'Family Tree Maker';
export const BRAND_NAME = 'Family Tree Maker Help Center';
export const SITE_DOMAIN = 'familytreemakerhelpcenter.com';
export const SITE_URL = 'https://www.familytreemakerhelpcenter.com';
export const SITE_TAGLINE = 'Independent support for setup, sync & everyday fixes';
export const COMPANY_NAME = 'Nodex Global LLC';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1} ${ADDRESS_LINE2}`;
export const POLICY_UPDATED = 'September 28, 2026';
export const META_DESCRIPTION =
  'Independent Family Tree Maker help center — installation, activation, FamilySync, TreeVault, media repair, and round-the-clock live chat for Windows and Mac.';

export const SUPPORT_PHONE_DISPLAY = '(844) 499-3050';
export const SUPPORT_PHONE_TEL = 'tel:+18444993050';
export const SUPPORT_PHONE_LABEL = '(844) 499-3050';

export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_a9df6a45537a524d1ea5805a68f7116a3bb38370f4de2c69';
export const LEAD_SOURCE = 'tree15';
